export default "__VITE_ASSET__BpEBQX_e__"